import { Session } from 'types/listings';

const getEndingDateForSession = (session: Session): Date =>
  new Date(
    new Date(session.startDateTime).getTime() + session.duration * 60 * 1000,
  );

export default getEndingDateForSession;
